// application/use-cases/Equipo/GetEquipoByIdUseCase.ts

import { Equipo } from '@/domain/entities/equipo';
import { IEquipoRepository } from '@/domain/repositories';

export class GetEquipoByIdUseCase {
  constructor(
    private readonly repository: IEquipoRepository
  ) {}

  execute(id: string): Promise<Equipo | null> {
    return this.repository.findById(id);
  }
}